const { createApp } = Vue

createApp({
    data() {
        return {
            eventSelected: false,
            activeInput: null,
            isResultLoading: false,
            eventName: null,
            eventType: null,
            eventId: null,
            events: [],
            autocompleteInitialized: false,
            bibNo: null,
            bibData: {},
            participantFlag: null,
            lastSearchedEvent: null,
            cachedEventsList: null,
            lastSearchedParticipant: null,
            cachedParticipantList: null,
            photoFile: null,
            photoPreviewUrl: null,
            photoCropper: null,
            showPhotoCrop: false,
            showPhotoOutput: false,
            croppedPhotoFile: null,
            outputImageUrl: null,
            isPhotoSubmitting: false,
            isFlipping: false,
        }
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        var urlSlug = urlParams.get('q');
        if (urlSlug) {
            const decodedSlug = atob(urlSlug);
            const urlData = JSON.parse(decodedSlug);
            this.eventName = urlData.e_name;
            this.eventId = urlData.e_id;
            this.eventSelected = true;
        }
    },
    methods: {
        resetBibData() {
            this.bibNo = null;
            this.bibData = {};
        },
        callApi(url, method, options, scroll = true) {
            if (scroll) {
                window.scrollTo(0, 0);
            }

            const delay_time = 200;

            const delay = new Promise(resolve => setTimeout(resolve, delay_time));

            const request = axios({
                method: method,
                url: url,
                ...options
            });

            this.isIpBlocked = false;
            return Promise.all([request, delay]).then(([response]) => {
                let decodedData = atob(response.data.data);
                let data = JSON.parse(decodedData);
                return data;
            }).catch(error => {
                if (error.status == 429 && error.response?.data?.ip_message) {
                    this.isIpBlocked = true;
                }
                window.scrollTo(0, 0);
                this.isResultLoading = false;
                return Promise.reject(error);
            });
        },
        triggerSwal(type, title = '', text = '') {
            Swal.fire({
                icon: type,
                title: title,
                text: text,
            });
        },
        triggerToast(type, text = '', pos = "top-right") {
            const arr = {
                'info': '#2196f3',
                'success': '#1abc9c',
                'error': '#e7515a'
            };
            Snackbar.show({
                text: text,
                pos: pos,
                actionTextColor: '#fff',
                backgroundColor: arr[type] || '#000'
            });
        },
        handleEventInput: _.debounce(function () {
            this.eventId = null;
            this.bibNo = null;
            this.eventSelected = false;
            this.triggerSearchEvent();
            if ($("#bibInputPC").autocomplete("instance")) {
                $("#bibInputPC").autocomplete("destroy");
            }
        }, 100),
        triggerSearchEvent() {
            if (!this.eventName || this.eventName.length < 3) {
                return 0;
            }
            this.searchEvent();
        },
        handleBibInput: _.debounce(function () {
            this.triggerSearchBib();
        }, 100),
        triggerSearchBib() {
            if (!this.eventId || !this.eventName || this.eventName.length < 3 || !this.bibNo || this.bibNo.length < 1) {
                return;
            }
            this.searchBib(this.eventId, this.bibNo);
        },
        resultFormSubmit(e) {
            if (this.eventName && this.eventId && this.bibNo) {
                this.fetchBibDetails(this.eventId, this.bibNo);
            }
        },
        searchEvent() {
            if (!this.eventName) {
                this.triggerToast('info', 'Please Enter Event Name')
                return 0;
            }
            if (this.autocompleteInitialized && $("#eventNameInputPC").autocomplete("instance")) {
                $("#eventNameInputPC").autocomplete("destroy");
            }
            const self = this;
            $("#eventNameInputPC").autocomplete({
                source: function (request, response) {
                    if (self.cachedEventsList && request.term && request.term === self.lastSearchedEvent) {
                        response(self.cachedEventsList);
                        return;
                    }

                    self.callApi('/frontend/api/event/live-result/event-search', 'get', {
                        params: {
                            name: request.term,
                        }
                    }).then(data => {
                        self.cachedEventsList = data.events.length === 0 ? [{ label: "No Events Found", value: "" }] : data.events.map(event => ({
                            label: event.highlight ? event.highlight : event.name,
                            value: event.event_id,
                            plainText: event.name
                        }));
                        self.lastSearchedEvent = request.term;
                        response(self.cachedEventsList);
                        $(".ui-autocomplete").each(function () {
                            $(this).toggleClass("ac-scroll-enabled", self.cachedEventsList.length > 5);
                        });
                    });
                },
                minLength: 3,
                autoFocus: false,
                focus: function (event, ui) {
                    $("#eventNameInputPC").val(ui.item.plainText || ui.item.label);
                    return false;
                },
                open: function () {
                    var parentWidth = $('#eventNameInputPC').outerWidth();
                    var parentTop = $('#eventNameInputPC').offset().top - 25;
                    var parentLeft = $('#eventNameInputPC').offset().left;
                    var parentHeight = $('#eventNameInputPC').outerHeight();

                    $("ul.ui-menu").css({
                        'width': parentWidth + 'px',
                        'top': parentTop + parentHeight + 'px',
                        'left': parentLeft + 'px'
                    });
                },
                select: function (event, ui) {
                    self.eventId = ui.item.value;
                    self.eventName = ui.item.plainText;
                    if (!ui.item.value || ui.item.value == "No Events Found") {
                        return false;
                    }
                    self.eventSelected = true;
                    self.$nextTick(() => {
                        if (self.$refs.bibNo) {
                            self.$refs.bibNo.focus();
                        }
                    });
                    return false;
                }
            });
            $("#eventNameInputPC").autocomplete("instance")._renderItem = function (ul, item) {
                return $("<li>")
                    .append($("<div>").html(item.label))
                    .appendTo(ul);
            };

            this.autocompleteInitialized = true;
            $("#eventNameInputPC").autocomplete("search", this.eventName);
        },
        searchBib(eventId, bibNo) {
            if (!eventId) {
                this.triggerToast('info', 'Please Enter Event Name')
                return;
            }
            if (!bibNo) {
                this.triggerToast('info', 'Please Enter Runner Name / BIB No.');
                return;
            }

            if (this.autocompleteInitialized && $("#bibInputPC").autocomplete("instance")) {
                $("#bibInputPC").autocomplete("destroy");
            }

            let condition = /^[A-Za-z\s]+$/.test(bibNo);
            if (condition && String(bibNo).trim().length < 3) {
                return 0;
            }

            const self = this;
            $("#bibInputPC").autocomplete({
                source: function (request, response) {
                    if (self.cachedParticipantList && self.bibNo === self.lastSearchedParticipant) {
                        response(self.cachedParticipantList);
                        return;
                    }

                    self.callApi('/frontend/api/event-bibs', 'get', {
                        params: {
                            event_id: self.eventId,
                            term: self.bibNo
                        }
                    }).then(data => {
                        self.cachedParticipantList = data.participants.length === 0
                            ? [{ label: "No Runners Found", value: null }]
                            : data.participants.map(p => ({
                                label: p.highlight ? `${p.highlight}  (${p.bibno})` : `${p.full_name}  (${p.bibno})`,
                                value: p.bibno,
                            }));
                        self.lastSearchedParticipant = self.bibNo;
                        response(self.cachedParticipantList);
                        $(".ui-autocomplete").each(function () {
                            $(this).toggleClass("ac-scroll-enabled", self.cachedParticipantList.length > 5);
                        });
                    });
                },
                minLength: 1,
                autoFocus: false,
                open: function () {
                    var parentWidth = $('#bibInputPC').outerWidth();
                    var parentTop = $('#bibInputPC').offset().top - 25;
                    var parentLeft = $('#bibInputPC').offset().left;
                    var parentHeight = $('#bibInputPC').outerHeight();

                    $("ul.ui-menu").css({
                        'width': parentWidth + 'px',
                        'top': parentTop + parentHeight + 'px',
                        'left': parentLeft + 'px'
                    });
                },
                select: function (event, ui) {
                    self.bibNo = ui.item.value;
                    if (!ui.item.value || ui.item.value == "No Runners Found") {
                        return false;
                    }
                    self.fetchBibDetails(self.eventId, self.bibNo);
                }
            });

            $("#bibInputPC").autocomplete("instance")._renderItem = function (ul, item) {
                return $("<li>")
                    .append($("<div>").html(item.label))
                    .appendTo(ul);
            };

            this.autocompleteInitialized = true;

            $("#bibInputPC").autocomplete("search", this.bibNo);
        },
        fetchBibDetails(eventId, bibNo) {
            if (!eventId || !bibNo) {
                return;
            }
            this.isResultLoading = true;
            this.eventType = null;
            this.callApi('/frontend/api/event/live-result/bib/rs', 'get', {
                params: {
                    event_id: eventId,
                    bib_no: bibNo,
                }
            }).then(data => {
                if (!data.status) {
                    this.bibData = {};
                    this.participantFlag = null;
                    this.isResultLoading = false;
                    this.triggerToast('error', data.message || 'Runner Not Found');
                    return;
                }
                this.bibData = data.runner_data;
                if (this.bibData.country_code) {
                    var flagUrl = "/frontend/flags/4x3/" + this.bibData.country_code.toLowerCase() + ".svg";
                    fetch(flagUrl)
                        .then(response => {
                            if (response.ok) {
                                this.participantFlag = flagUrl;
                            } else {
                                this.participantFlag = null;
                            }
                        })
                        .catch(error => {
                            this.participantFlag = null;
                        });
                } else {
                    this.participantFlag = null;
                }

                this.isResultLoading = false;
            });
        },
        handlePhotoSelect(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (!file.type.startsWith('image/')) {
                this.triggerToast('error', 'Please select an image.');
                event.target.value = '';
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                this.triggerToast('error', 'Image size must not exceed 10 MB');
                event.target.value = '';
                return;
            }

            if (this.photoPreviewUrl) {
                URL.revokeObjectURL(this.photoPreviewUrl);
            }
            if (this.outputImageUrl) {
                URL.revokeObjectURL(this.outputImageUrl);
            }

            this.photoFile = file;
            this.photoPreviewUrl = URL.createObjectURL(file);

            this.showPhotoCrop = true;
            this.showPhotoOutput = false;

            this.$nextTick(() => {
                this.initializePhotoCrop();
            })

        },
        initializePhotoCrop() {
            const image = document.getElementById('photoCropImage');
            if (!image) return;

            if (this.photoCropper) {
                this.photoCropper.destroy();
                this.photoCropper = null;
            }

            this.photoCropper = new Cropper(image, {
                aspectRatio: 1.681,
                viewMode: 1,
                dragMode: 'move',
                autoCropArea: 0.8,
                responsive: true,
                background: false,
                guides: false,
                center: true,
                movable: true,
                zoomable: true,
                scalable: false,
                rotatable: false,
            });
        },
        async cropPhoto() {
            if (!this.photoCropper) {
                return;
            }

            const canvas = this.photoCropper.getCroppedCanvas({
                imageSmoothingEnabled: true,
                imageSmoothingQuality: 'high'
            });

            canvas.toBlob(async (blob) => {
                if (!blob) {
                    this.triggerToast('error', 'Unable to crop image.');
                    return;
                }

                this.croppedPhotoFile = new File(
                    [blob],
                    'photo.jpg',
                    {
                        type: 'image/jpeg'
                    }
                );

                if (this.photoPreviewUrl) {
                    URL.revokeObjectURL(this.photoPreviewUrl);
                }
                this.photoPreviewUrl = URL.createObjectURL(blob);

                this.destroyPhotoCrop();
                this.isPhotoSubmitting = true;

                try {
                    const formData = new FormData();
                    if (this.bibData.chip_time) {
                        formData.append('chip_time', this.bibData.chip_time);
                    }
                    if (this.bibData.gun_time) {
                        formData.append('gun_time', this.bibData.gun_time);
                    }

                    formData.append('event_id', this.eventId);
                    formData.append('bib_no', this.bibNo);
                    formData.append('image', this.croppedPhotoFile);
                    formData.append('name', this.bibData.runnerShortName);
                    formData.append('race_name', this.bibData.race_name);
                    formData.append('race_date', this.bibData.race_date);
                    formData.append('hash', this.bibData.raceSelfieHash);
                    formData.append('bib_type', this.bibData.type);

                    const raceSelfieProcessingUrl = `${window.location.origin}/race-selfie/submit`;
                    const response = await axios.post(raceSelfieProcessingUrl, formData,
                        {
                            responseType: 'blob'
                        }
                    );
                    const imageBlob = response.data;

                    if (this.outputImageUrl) {
                        URL.revokeObjectURL(
                            this.outputImageUrl
                        );
                    }

                    this.outputImageUrl =
                        URL.createObjectURL(imageBlob);

                    this.showPhotoCrop = false;
                    this.showPhotoOutput = true;

                    // this.updateParticipantStats('race_selfie_generated');
                } catch (error) {
                    console.error('Race Selfie API error:', error);
                    this.triggerToast('error', 'Unable to generate Race Selfie.');
                    this.showPhotoCrop = true;
                    this.$nextTick(() => {
                        this.initializePhotoCrop();
                    });
                } finally {
                    this.isPhotoSubmitting = false;
                }
            }, 'image/jpeg', 0.9);
        },
        flipPhoto() {
            if (!this.photoPreviewUrl || this.isPhotoSubmitting || this.isFlipping) return;
            this.isFlipping = true;

            const oldUrl = this.photoPreviewUrl;
            const img = new Image();

            img.onload = () => {
                try {
                    const MAX = 2000;
                    const scale = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
                    const w = Math.round(img.naturalWidth * scale);
                    const h = Math.round(img.naturalHeight * scale);

                    const canvas = document.createElement('canvas');
                    canvas.width = w;
                    canvas.height = h;

                    const ctx = canvas.getContext('2d');
                    ctx.translate(w, 0);
                    ctx.scale(-1, 1);
                    ctx.drawImage(img, 0, 0, w, h);

                    canvas.toBlob((blob) => {
                        this.isFlipping = false;
                        if (!blob) {
                            this.triggerToast('error', 'Unable to flip image.');
                            return;
                        }
                        this.destroyPhotoCrop();
                        this.photoPreviewUrl = URL.createObjectURL(blob);
                        URL.revokeObjectURL(oldUrl);
                        this.$nextTick(() => this.initializePhotoCrop());
                    }, 'image/jpeg', 0.92);
                } catch (e) {
                    this.isFlipping = false;
                    console.error('Flip failed:', e);
                    this.triggerToast('error', 'Unable to flip image.');
                }
            };

            img.onerror = () => {
                this.isFlipping = false;
                this.triggerToast('error', 'Unable to flip image.');
            };

            img.src = oldUrl;
        },
        destroyPhotoCrop() {
            if (this.photoCropper) {
                this.photoCropper.destroy();
                this.photoCropper = null;
            }
        },
        cancelPhotoCrop() {
            if (this.isPhotoSubmitting) return;

            this.destroyPhotoCrop();

            if (this.photoPreviewUrl) {
                URL.revokeObjectURL(this.photoPreviewUrl);
            }

            this.photoFile = null;
            this.photoPreviewUrl = null;
            this.croppedPhotoFile = null;
            this.outputImageUrl = null;

            this.showPhotoCrop = false;
            this.showPhotoOutput = false;
            this.isPhotoSubmitting = false;

            const input = document.getElementById('photoInput');
            if (input) {
                input.value = "";
            }
        },
        retakePhoto() {
            if (this.isPhotoSubmitting) return;
            this.destroyPhotoCrop();
            if (this.photoPreviewUrl) {
                URL.revokeObjectURL(this.photoPreviewUrl);
            }
            if (this.outputImageUrl) {
                URL.revokeObjectURL(this.outputImageUrl);
            }

            this.photoFile = null;
            this.photoPreviewUrl = null;
            this.croppedPhotoFile = null;
            this.outputImageUrl = null;

            this.showPhotoCrop = false;
            this.showPhotoOutput = false;
            this.isPhotoSubmitting = false;

            const input = document.getElementById('photoInput');
            if (input) {
                input.value = '';
            }
        },
        downloadRaceSelfie() {
            if (!this.outputImageUrl) {
                return;
            }

            const link = document.createElement('a');
            link.href = this.outputImageUrl;
            link.download = 'race-selfie-' + this.bibNo + '.png';

            document.body.appendChild(link);
            link.click();
            link.remove();

            this.updateParticipantStats('race_selfie_downloaded');
        },
        async sharePhoto() {
            if (!this.outputImageUrl) return;

            try {
                const response = await fetch(this.outputImageUrl);
                const blob = await response.blob();
                const file = new File(
                    [blob],
                    'race-selfie-' + this.bibNo + '.png',
                    {
                        type: 'image/png'
                    }
                );

                if (navigator.share && navigator.canShare &&
                    navigator.canShare({
                        files: [file]
                    })
                ) {
                    await navigator.share({
                        title: 'My Race Selfie',
                        text: 'My Race Selfie',
                        files: [file]
                    });
                    this.updateParticipantStats('race_selfie_shared');
                    return;
                }

                if (navigator.share) {
                    await navigator.share({
                        title: 'My Race Selfie',
                        text: 'My Race Selfie',
                        url: this.outputImageUrl
                    });
                    this.updateParticipantStats('race_selfie_shared');
                    return;
                }

                this.triggerToast('info', 'Sharing is not supported on this device.');
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error(
                        'Share error:',
                        error
                    );
                    this.triggerToast('info', 'Something went wrong.');
                }
            }
        },
        resetRaceSelfie() {
            if (this.photoCropper) {
                this.photoCropper.destroy();
                this.photoCropper = null;
            }

            if (this.photoPreviewUrl) {
                URL.revokeObjectURL(this.photoPreviewUrl);
            }

            if (this.outputImageUrl) {
                URL.revokeObjectURL(this.outputImageUrl);
            }

            this.photoFile = null;
            this.photoPreviewUrl = null;
            this.showPhotoCrop = false;
            this.showPhotoOutput = false;
            this.croppedPhotoFile = null;
            this.outputImageUrl = null;
            this.isPhotoSubmitting = false;

            const input = document.getElementById('photoInput');
            if (input) {
                input.value = '';
            }
        },
        updateParticipantStats(type) {
            this.callApi('/frontend/api/event/update-participant-stats', 'post', {
                params: {
                    event_id: this.eventId,
                    bib_no: this.bibNo,
                    stat_type: type
                }
            }, false).then(data => {
            }).catch(error => { });
        },
    },
    watch: {
        bibNo(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.resetRaceSelfie();
            }
        },
    },
}).mount('#app')
